import React from 'react';
import { Link } from 'react-router-dom';
import BusinessBranding from './BusinessBranding';

const Footer = ({ business = null }) => {
    const year = new Date().getFullYear();

    return (
        <footer className="site-footer">
            <div className="container">
                <BusinessBranding business={business} />
                <p className="footer-copy">&copy; {year} Snox. All rights reserved.</p>
                <p className="footer-links">
                    <a href="https://snoxpro.com/terms_and_conditions.html">Terms of Service</a>
                    {' | '}
                    <a href="https://snoxpro.com/privacy_policy.html">Privacy Policy</a>
                </p>
                <Link to="/" className="footer-logo-link" aria-label="Snox Home">
                    <img src="/snox-logo.png" alt="Snox" className="footer-logo" />
                </Link>
            </div>
        </footer>
    );
};

export default Footer;
